import { Link, useNavigate } from "react-router-dom";
import { LogOut, Shield, UserRound } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LOGO_SBG_COLOR } from "@/lib/logos";

export default function SiteNav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 border-b border-sbg-raspberry/15 bg-background/85 backdrop-blur-xl">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3.5">
        <Link to="/" data-testid="nav-home-link" className="group flex items-center gap-3">
          <img src={LOGO_SBG_COLOR} alt="Southern Black Girls and Women's Consortium" className="h-9 w-auto sm:h-11" />
          <span className="hidden border-l border-sbg-raspberry/20 pl-3 text-[11px] font-semibold uppercase tracking-[0.18em] text-sbg-raspberry sm:block">
            Toolkits
          </span>
        </Link>

        <nav className="flex items-center gap-1.5 sm:gap-3">
          {user?.is_staff && (
            <Link
              to="/admin"
              data-testid="nav-admin-link"
              className="flex items-center gap-1.5 rounded-full px-3 py-2 text-sm font-semibold text-pt-purple transition-colors hover:bg-pt-lavender/20"
            >
              <Shield className="h-4 w-4" /> Admin
            </Link>
          )}
          {user?.is_staff && (
            <Link
              to="/account"
              data-testid="nav-account-link"
              title="My account & notifications"
              className="flex items-center gap-1.5 rounded-full px-3 py-2 text-sm font-semibold text-sbg-burgundy transition-colors hover:bg-sbg-blush/60"
            >
              <UserRound className="h-4 w-4" /> <span className="hidden sm:inline">My account</span>
            </Link>
          )}
          {user?.winner_slug && (
            <Link
              to={`/bgjcpt/${user.winner_slug}`}
              data-testid="nav-my-page-link"
              title="View my page"
              className="flex max-w-[160px] items-center gap-1.5 rounded-full bg-sbg-blush/60 px-3 py-2 text-sm font-semibold text-sbg-burgundy transition-colors hover:bg-sbg-blush"
            >
              <UserRound className="h-4 w-4 shrink-0" />
              <span className="truncate">{user.winner_name || "My page"}</span>
            </Link>
          )}
          {user ? (
            <button
              data-testid="nav-logout-btn"
              onClick={() => {
                logout();
                navigate("/");
              }}
              className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-sbg-burgundy px-4 py-2 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5"
            >
              <LogOut className="h-4 w-4" /> Sign out
            </button>
          ) : (
            <Link
              to="/login"
              data-testid="nav-login-link"
              className="rounded-full bg-sbg-raspberry px-4 py-2 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5"
            >
              Sign in
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
